import styled from '@emotion/styled'
import {theme} from '../../theme'

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[1]};
  padding-bottom: ${theme.space[4]};
  border-bottom: 1px solid ${theme.colors.border.light};
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space[5]};
  padding: ${theme.space[4]} 0;
`

export const FooterRow = styled.div`
  display: flex;
  gap: ${theme.space[3]};
  width: 100%;

  & > * {
    flex: 1;
  }
`
